export interface RankEntry {
  rank: number;
  name: string;
  mileage: number;
  level: 'level1' | 'level2' | 'level3' | 'master';
}

export function getLevelInfo(mileage: number) {
  if (mileage >= 16) {
    return {
      level: 'master' as const,
      label: '마스터',
      color: 'bg-amber-500',
      textColor: 'text-amber-700',
      bgColor: 'bg-amber-50',
      borderColor: 'border-amber-200',
      image: '/images/master.png',
      alt: '마스터 캐릭터',
    };
  }
  if (mileage >= 11) {
    return {
      level: 'level3' as const,
      label: '레벨 3',
      color: 'bg-emerald-500',
      textColor: 'text-emerald-700',
      bgColor: 'bg-emerald-50',
      borderColor: 'border-emerald-200',
      image: '/images/level3.png',
      alt: '레벨 3 캐릭터',
    };
  }
  if (mileage >= 6) {
    return {
      level: 'level2' as const,
      label: '레벨 2',
      color: 'bg-teal-500',
      textColor: 'text-teal-700',
      bgColor: 'bg-teal-50',
      borderColor: 'border-teal-200',
      image: '/images/level2.png',
      alt: '레벨 2 캐릭터',
    };
  }
  return {
    level: 'level1' as const,
    label: '레벨 1',
    color: 'bg-sky-500',
    textColor: 'text-sky-700',
    bgColor: 'bg-sky-50',
    borderColor: 'border-sky-200',
    image: '/images/level1.png',
    alt: '레벨 1 캐릭터',
  };
}

export function getNextLevelInfo(mileage: number) {
  if (mileage >= 16) return { nextLabel: '최고 레벨 달성!', remaining: 0, progress: 100 };
  if (mileage >= 11) return { nextLabel: '마스터', threshold: 16, remaining: 16 - mileage, progress: ((mileage - 11) / 5) * 100 };
  if (mileage >= 6) return { nextLabel: '레벨 3', threshold: 11, remaining: 11 - mileage, progress: ((mileage - 6) / 5) * 100 };
  return { nextLabel: '레벨 2', threshold: 6, remaining: 6 - mileage, progress: (mileage / 6) * 100 };
}